module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow-3422ee4a9fcdd2e36497be7fe03a2b64.png";